import { motion, useInView, useMotionValue, useSpring } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

const StatCard = ({ number, label, delay = 0, prefix = '', suffix = '' }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const motionValue = useMotionValue(0);
  const springValue = useSpring(motionValue, { duration: 2000 });
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    if (isInView) {
      // Parse the number if it's a string (e.g., "8,700" -> 8700)
      const targetNumber = typeof number === 'string' 
        ? parseFloat(number.replace(/,/g, '')) 
        : number;
      
      setTimeout(() => {
        motionValue.set(targetNumber);
      }, delay * 1000);
    }
  }, [isInView, number, delay, motionValue]);

  useEffect(() => {
    const unsubscribe = springValue.on('change', (latest) => {
      setDisplayValue(latest);
    });
    return unsubscribe;
  }, [springValue]);

  // Format number based on original format
  const formatNumber = (value) => {
    if (typeof number === 'string' && number.includes(',')) {
      return Math.round(value).toLocaleString();
    }
    if (typeof number === 'string' && number.includes('.')) {
      return value.toFixed(2);
    }
    return Math.round(value);
  };

  return (
    <motion.div
      ref={ref}
      className="text-center"
      initial={{ opacity: 0, y: 20 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay }}
    >
      <div className="text-4xl md:text-5xl font-mono font-bold text-white mb-2">
        {prefix}
        <span>
          {formatNumber(displayValue)}
        </span>
        {suffix}
      </div>
      <div className="text-lg md:text-xl text-white/90 font-light">
        {label}
      </div>
    </motion.div>
  );
};

export default StatCard;
